import React from 'react';
import { Link } from 'react-router-dom';
import { useLocalization } from '../contexts/LocalizationContext';
import './ErrorPage.css';

const ErrorPage = ({ type = '404' }) => {
  const { t, language, loading } = useLocalization();
  
  // Debug localization
  console.log('ErrorPage - language:', language, 'loading:', loading);
  console.log('ErrorPage - t function:', typeof t);
  
  const is404 = type === '404';
  const imageSrc = is404 ? '/assets/img/404.png' : '/assets/img/internal-error.png';
  
  // Handle loading state
  if (loading) {
    return (
      <div className="error-page">
        <div className="error-content">
          <p>Loading...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="error-page">
      <div className="error-content">
        <div className="error-image-container">
          <img 
            src={imageSrc} 
            alt={is404 ? t('error.notFoundTitle', '404 Not Found') : t('error.serverErrorTitle', 'Internal Error')}
            className="error-image"
          />
        </div>
        
        <div className="error-text">
          <h1 className="error-title">
            {is404 ? t('error.notFoundTitle', '404 - Page Not Found') : t('error.serverErrorTitle', '500 - Internal Server Error')}
          </h1>
          
          <p className="error-message">
            {is404 
              ? t('error.notFoundMessage', 'Sorry, the page you are looking for does not exist.')
              : t('error.serverErrorMessage', 'Something went wrong on our end. Please try again later.')
            }
          </p>
          
          <div className="error-actions">
            <Link to="/" className="btn btn-primary">
              {t('error.goHome', 'Go to Home')}
            </Link>
            
            {!is404 && (
              <button 
                onClick={() => window.location.reload()} 
                className="btn btn-secondary"
              >
                {t('error.reload', 'Try Again')}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;